<template>
  <div class="registration-page transfer-company-section">
    <div class="registration-page-container">
      <div
        class="section"
        v-if="openMarketInfo.rotrRqstCd === 'N' && registration.dutyAgmtSuptAmt"
      >
        <div class="section-header"><h3>의무약정</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              의무약정
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ retrieveData.agmtTermMmct }}
                  <span
                    v-if="
                      registration.dutyAgmtSuptAmt !== ''
                    "
                    >{{ retrieveData.dutyAgmtSuptAmt }} 원</span
                  >
                </p>
              </div>
              <div class="field-control-sub">
                <a
                  id="popDutyDesc"
                  @click="dutyDesc"
                  title="새창열림"
                  target="_blank"
                  class="link-detail"
                  >상세보기</a
                >
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div class="section" v-if="openMarketInfo.rotrRqstCd === 'Y'">
        <div class="section-header"><h3>의무약정</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              약정지원금액
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ retrieveData.rotrAgmtAmt }} 원</p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              월청구금액
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  0 원
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              약정기간
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ registration.rotrAgmtMmct }}개월</p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              위약금액
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ retrieveData.rotrAgmtAmt }} 원</p>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
import { common } from '~/js/common'
export default {
  name: 'RouterAgreedSectionView',

  props: {
    registrationProps: Object,
    openMarketInfoProps: Object
  },

  data() {
    return {
      registration: {},
      openMarketInfo: {},
      retrieveData: {
        rotrAgmtAmt: '',
        dutyAgmtSuptAmt: '',
        agmtTermMmct: ''
      }
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.openMarketInfo = this.openMarketInfoProps
    this.retrieveData.rotrAgmtAmt = this.commaAmt(this.registration.rotrAgmtAmt)
    this.retrieveData.dutyAgmtSuptAmt = this.commaAmt(
      this.registration.dutyAgmtSuptAmt
    )
    this.retrieveData.agmtTermMmct =
      this.registration.agmtTermMmct === '0'
        ? '무약정'
        : this.registration.agmtTermMmct + ' 개월'
  },
  computed: {
    pricePerMonth() {
      return '0'
    },

    routrAgrPrice() {
      return '0'
    }
  },

  methods: {
    /** 
     * Function    : dutyDesc
     * Description : 의무약정 상세보기
     **/
    dutyDesc(e) {
      e.preventDefault()
      window.open(
        'https://www.lguplus.com/support/service/use-guide/detail?ugBnnrCd=B02',
        'PopupWin',
        'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
      )
    },

    /** 
     * Function    : commaAmt
     * Description : 판매 금액 "," 넣기
     **/
    commaAmt(amt) {
      let amtData = amt ? amt : 0
      return common.comma(amtData)
    }
  }
}
</script>

<style scoped></style>
